import { render, staticRenderFns } from "./SatisfactionQuestionsList.vue?vue&type=template&id=4892268b"
import script from "./SatisfactionQuestionsList.vue?vue&type=script&lang=js"
export * from "./SatisfactionQuestionsList.vue?vue&type=script&lang=js"
import style0 from "./SatisfactionQuestionsList.vue?vue&type=style&index=0&id=4892268b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports